import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Navigate } from 'react-router-dom';

export default function Login() {
  const { token, login } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  if (token) return <Navigate to="/chat" replace />;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    const result = await login(email, password);
    setLoading(false);
    if (!result.ok) {
      if (result.status === 429) {
        setError('Troppi tentativi. Riprova tra 15 minuti.');
      } else {
        setError(result.detail || 'Email o password non validi');
      }
    }
  };

  return (
    <div className="login-page">
      <div className="login-card">
        <svg width="60" height="84" viewBox="0 0 100 140" style={{display:'block', margin:'0 auto 16px'}}>
          <ellipse cx="50" cy="55" rx="36" ry="43" fill="none" stroke="#AFA9EC" strokeWidth="5" opacity="0.20"/>
          <ellipse cx="50" cy="55" rx="23" ry="30" fill="none" stroke="#AFA9EC" strokeWidth="3.5" opacity="0.35"/>
          <ellipse cx="50" cy="55" rx="14" ry="19" fill="none" stroke="#AFA9EC" strokeWidth="2.5" opacity="0.55"/>
          <ellipse cx="50" cy="55" rx="9" ry="11" fill="none" stroke="#CECBF6" strokeWidth="1.8" opacity="0.75"/>
          <ellipse cx="50" cy="55" rx="5" ry="7" fill="#EEEDFE"/>
        </svg>
        <h1>ERMENE</h1>
        <p className="login-subtitle">decision intelligence</p>
        <form onSubmit={handleSubmit}>
          <input
            type="email"
            value={email}
            onChange={e => setEmail(e.target.value)}
            placeholder="Email"
            required
            autoFocus
            disabled={loading}
          />
          <input
            type="password"
            value={password}
            onChange={e => setPassword(e.target.value)}
            placeholder="Password"
            required
            disabled={loading}
          />
          {error && <div className="login-error">{error}</div>}
          <button type="submit" disabled={loading}>
            {loading ? 'Accesso...' : 'Accedi'}
          </button>
        </form>
      </div>
    </div>
  );
}
